// app/features/ai-agent-conversations/services_and_hooks/conversationsService.ts
import { ConversationWithCustomer, ConversationWithMessages } from '../ai-agent-conversations.interface';

export const conversationsService = {
  async getConversationsByOrganization(organizationId: string): Promise<ConversationWithCustomer[]> {
    const response = await fetch(`/api/conversations/by-organization/${organizationId}`);
    
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Failed to fetch conversations');
    }
    
    return response.json();
  },

  async getConversationsByBrand(brandId: string): Promise<ConversationWithCustomer[]> {
    const response = await fetch(`/api/conversations/by-brand/${brandId}`);
    
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Failed to fetch conversations');
    }
    
    return response.json();
  },

  async getConversationById(conversationId: string): Promise<ConversationWithMessages | null> {
    const response = await fetch(`/api/conversations/${conversationId}`);
    
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Failed to fetch conversation');
    }
    
    return response.json();
  }
};
